module.exports = __webpack_public_path__ + "img/grayIcons.10b0d9c8.png";